import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import Container from "../../components/Container";
import Page from "../../components/Page";
import FormButton from "../../components/FormButton";
import FormTextInput from "../../components/FormTextInput";
import AddEditDoctorModal from "../../components/AddEditDoctorModal";
import UseDebounce from "../../components/UseDebounce";
import ConfirmAlertBox from "../../components/ConfirmAlertBox";
import AlertMsg from "../../components/AlertMsg";
import { MOBILE_VIEW } from "../../components/Sidebar";

import { connect } from "react-redux";
import {DELETE_DOCTOR_SUCCESS} from "../../redux/actions/types";
import {
  listDoctor,
  deleteDoctor,
  updateApiStatus,
} from "../../redux/actions/userDataActions";

import styles from "./Doctors.module.css";

import "../../assets/css/custom.css";

import EditIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PlusIcon from '@mui/icons-material/AddOutlined';
import ExclaimIcon from '@mui/icons-material/ErrorOutlineOutlined';

import {UTC_OFFSET} from "../../constants";

const Doctors = (props) => {
  const [pageNum, setPageNum] = useState(1);
  const [search, setSearch] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [type, setType] = useState("");
  const [selectedDoctorData, setSelectedDoctorData] = useState(null);
  const [confirmBoxVisible, setConfirmBoxVisible] = useState(false);
  const [totalListCount, setTotalListCount] = useState("");
  const [listCount, setListCount] = useState("");
  const [pageLimit, setPageLimit] = useState(50);

  const debouncedSearch = UseDebounce(search, 500);

  const navigate = useNavigate();

  useEffect(() => {
    if (props.apiStatus == DELETE_DOCTOR_SUCCESS && confirmBoxVisible) {
      setSelectedDoctorData(null);
      setConfirmBoxVisible(false);
      props.updateApiStatus("");
    }
  }, [props.apiStatus]);

  useEffect(() => {
    setTotalListCount(props.doctorTotalList);
  }, [props.doctorTotalList]);

  useEffect(() => {
    setListCount(props.doctorList?.length);
  }, [props.doctorList?.length]);

  useEffect(() => {
    getDoctorList(1);
  }, [debouncedSearch]);

  useEffect(() => {
    getDoctorList(1);
  }, []);

  const getDoctorList = (page) => {
    let data = {
      page: page,
      searchDoctor: search,
    };
    props.listDoctor(JSON.stringify(data));
    setPageNum(page);
  };

  const onAddEditDoctorBtnClick = (e, val, item) => {
    e.stopPropagation();
    setSelectedDoctorData(item);
    setType(val);
    setModalVisible(true);
  };

  const onAddEditDoctor = () => {
    setSelectedDoctorData(null);
    setModalVisible(false);
  };

  const onCancelDoctor = () => {
    setSelectedDoctorData(null);
    setModalVisible(false);
  };

  const onSelectPage = (page) => {
    getDoctorList(page);
  };

  const onSearchDoctors = (val) => {
    setSearch(val);
  };

  const onDeleteDoctorBtnClick = (e, item) => {
    e.stopPropagation();
    setSelectedDoctorData(item);
    setConfirmBoxVisible(true);
  };

  const onConfirmDeleteDoctor = () => {
    let data = {
      doctorUid: selectedDoctorData?.uid,
    };
    props.deleteDoctor(JSON.stringify(data));
  };

  const onCancelDeleteDoctor = () => {
    setSelectedDoctorData(null);
    setConfirmBoxVisible(false);
  };

  const onViewClick = (data) => {
    navigate("/doctor_view?id=" + data?.uid);
  };

  return (
    <Container page={"doctors"}>
      <Grid container item md={12} xs={12}>
        <Grid
          item
          md={12}
          xs={12}
          container
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          className={styles.cardView}
        >
          <TableContainer className={styles.tableView}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell colSpan={11}>
                    <Grid
                      display={"flex"}
                      flexDirection={"row"}
                      justifyContent={"flex-end"}
                      mt={2}
                    >
                      <Grid item md={2} xs={2}>
                        <FormTextInput
                          page={"Doctors"}
                          value={search}
                          setValue={(val) => onSearchDoctors(val)}
                          height={40}
                          width={150}
                          placeholder={"Search.."}
                        />
                      </Grid>
                      <Grid item md={2} xs={2} ml={2}>
                        <FormButton
                          title={
                            MOBILE_VIEW ? (
                              <PlusIcon />
                            ) : (
                              "Add New Doctor"
                            )
                          }
                          startIcon={
                            MOBILE_VIEW ? null : (
                              <PlusIcon />
                            )
                          }
                          btnStyleView={style.btnStyleView}
                          onSubmit={(e) =>
                            onAddEditDoctorBtnClick(e, "add", null)
                          }
                        />
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Hospital</TableCell>
                  <TableCell>Mobile</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Added Date</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.doctorLoading ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : props.doctorList?.length > 0 ? (
                  props.doctorList?.map((item, index) => (
                    <TableRow
                      key={index}
                      className={styles.tableRowView}
                      onClick={(e) => onViewClick(item)}
                    >
                      <TableCell>{item?.name}</TableCell>
                      <TableCell>{item?.hospital}</TableCell>
                      <TableCell>{item?.mobile}</TableCell>
                      <TableCell>
                        <Box className={styles.statusView}>
                          <Typography className={styles.statusText}>
                            {item?.status}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>{moment.utc(item?.timestamp).utcOffset(UTC_OFFSET).format("DD-MM-Y hh:mm A")}</TableCell>
                      <TableCell>
                        <Box className={styles.iconMainView}>
                          <Box
                            onClick={(e) =>
                              onAddEditDoctorBtnClick(e, "edit", item)
                            }
                            className={styles.iconView}
                          >
                            <EditIcon fontSize="small" />
                          </Box>
                          <Box
                            onClick={(e) => onDeleteDoctorBtnClick(e, item)}
                            ml={1}
                            className={styles.iconView}
                          >
                            <DeleteIcon fontSize="small" />
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={11} align="center">
                      <Typography className={styles.noMatchFoundText}>
                        No Doctors found
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Grid
            item
            md={12}
            xs={12}
            display={"flex"}
            flexDirection={{ md: "row", xs: "column" }}
            alignItems={"center"}
          >
            <Grid
              item
              md={6}
              xs={12}
              display={"flex"}
              justifyContent={{ md: "flex-start", xs: "unset" }}
              mt={2}
              mb={{ md: 2, xs: 0 }}
              pl={{ md: 2, xs: 0 }}
            >
              <Typography className={styles.showingEntriesText}>
                Showing{" "}
                {listCount == 0
                  ? 0
                  : pageNum == 1
                    ? 1
                    : parseInt((pageNum - 1) * pageLimit) + 1}{" "}
                to{" "}
                {listCount == 0
                  ? 0
                  : parseInt((pageNum - 1) * pageLimit) + listCount}{" "}
                of {totalListCount} entries
              </Typography>
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
              display={"flex"}
              justifyContent={{ md: "flex-end", xs: "unset" }}
              mt={2}
              mb={2}
              pr={{ md: 2, xs: 0 }}
            >
              <Page
                totalPages={props.doctorTotalPages}
                pageNum={pageNum}
                onSelectPage={onSelectPage}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <AddEditDoctorModal
        type={type}
        data={selectedDoctorData}
        modalVisible={modalVisible}
        onCancel={onCancelDoctor}
        onSubmit={onAddEditDoctor}
      />

      <ConfirmAlertBox
        confirmBox={confirmBoxVisible}
        icon={<ExclaimIcon sx={{height: 80, width: 80, color: '#ffc700'}}/>}
        title={"Are you sure?"}
        content={"You won't be able to revert this!"}
        btnLoading={props.doctorBtnLoading}
        firstBtn={"Yes, delete it!"}
        secondBtn={"Cancel"}
        onConfirmClick={onConfirmDeleteDoctor}
        onCancelClick={onCancelDeleteDoctor}
      />

      <AlertMsg />
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    doctorTotalPages: state.userData.doctorTotalPages,
    doctorTotalList: state.userData.doctorTotalList,
    doctorList: state.userData.doctorList,
    doctorLoading: state.userData.doctorLoading,
    doctorBtnLoading: state.userData.doctorBtnLoading,
    apiStatus: state.userData.apiStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    listDoctor: (data) => dispatch(listDoctor(data)),
    deleteDoctor: (data) => dispatch(deleteDoctor(data)),
    updateApiStatus: (data) => dispatch(updateApiStatus(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Doctors);

const style = {
  btnStyleView: {
    height: 40,
    width: "100%",
  },
};
